// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  env: 'dev',
  settings: {
    backend: "api.myapp.com",
    otherurl: "other_url"
  },
  //apiBase: 'https://schoolapi.nexsharp.in/backendservice/api',
  //authBase: 'https://auth.nexsharp.in/authservice',
  //companyBase: 'https://companyapi.nexsharp.in/api',
  apiBase: 'SCHOOLAPI_BASE_URL_PLACEHOLDER',
  authBase: 'AUTH_BASE_URL_PLACEHOLDER',
  companyBase: 'COMPAPI_BASE_URL_PLACEHOLDER',
  clientLogoUrl: '/api/client/getLogo/',  
  authorizeAPI: '/oauth/authorize',
  getTokenAPI: '/oauth/token',  
  //redirectURI: 'http://194.238.19.142:7001',
  //clientId: 'tSubnlTtQOFhm4YM',// oauth2-jwt-client, tSubnlTtQOFhm4YM 
  //clientName: 'TestClient',
  authUserInfoAPI: '/api/users/me',
  //userInfoAPI: '/profile/username',
  userInfoAPI: '/api/user',
  
  configFile: 'assets/config/config.json', //TODO- to read from local drive
  configPublicFile: 'https://jsonplaceholder.typicode.com/todos/1',
  configClient: '/api/clientinfo',
  defaultTenant: 'dps',
  
  sessionTimeOut: 120000, // in millisecond
  sessionProgressBarTime: 30000, // in ms

  dtOnlyFormatDefault:'yyyy-MM-dd',
  dtFormatDefault:'dd/MM/yyyy HH:mm:ss', //dd/MM/yyyy hh:mm:ss aa
  minDate: {year: 1970, month: 1, day: 1},
  maxDate: {year: 2030, month:1, day: 1},
  //{{invoice.dueDate | date}}  results like - 'Dec 21, 2022'
  //Below are used only for showing in default section of profile..
  hrFormatDefault:'24 Hr', 
  timezoneDefault:'UTC', 
  currencyDefault:'INR',

  secret_store: 'secret_store',
  local_store: 'LOCAL',
  cloud_store: 'CLOUD',
  dummyFile: 'dummy.txt',
  ALL: 'ALL',
  
  yearList: [{ id: 2023, name: "2023"},{ id: 2024, name: "2024"},{ id: 2025, name: "2025"},{ id: 2026, name: "2026"},{ id: 2027, name: "2027"},{ id: 2028, name: "2028"}],
  monthList: [{ id: 'Jan', name: "January" },{ id: 'Feb', name: "February" },{ id: 'Mar', name: "March" }, { id: 'Apr', name: "April" }, { id: 'May', name: "May" },{ id: 'Jun', name: "June" },{ id: 'Jul', name: "July" },{ id: 'Aug', name: "August" },{ id: 'Sep', name: "September" },{ id: 'Oct', name: "October" },{ id: 'Nov', name: "November" },{ id: 'Dec', name: "December" },],
  dayList: [{ id: 1, name: "Monday" },{ id: 2, name: "Tuesday" },{ id: 3, name: "Wednesday" }, { id: 4, name: "Thursday" }, { id: 5, name: "Friday" },],
  secondsList: [{ id: 15, name: "15" },{ id: 30, name: "30" },{ id: 50, name: "50" }],
  minutesList: [{ id: 2, name: "2" },{ id: 15, name: "15" },{ id: 30, name: "30" },{ id: 45, name: "45" }],
  hoursList: [{ id: 6, name: "6" },{ id: 7, name: "7" },{ id: 18, name: "18" },{ id: 19, name: "19" }],
  dayNumberList: [{ id: 1, name: "1" },{ id: 2, name: "2" },{ id: 3, name: "3" }, { id: 4, name: "4" }, { id: 5, name: "5" },{ id: 6, name: "6" },{ id: 7, name: "7" },{ id: 8, name: "8" },{ id: 9, name: "9" },{ id: 10, name: "10" },{ id: 15, name: "15" },{ id: 20, name: "20" },{ id: 25, name: "25" },{ id: 30, name: "30" }],
  numberList: [{ id: 1, name: "1" },{ id: 2, name: "2" },{ id: 3, name: "3" }, { id: 4, name: "4" }, { id: 5, name: "5" },],
  sequenceList: [{ id: 0, name: "NA" },{ id: 1, name: "1" },{ id: 2, name: "2" },{ id: 3, name: "3" }, { id: 4, name: "4" }, { id: 5, name: "5" },],
  secretLocationList: [{ id: 'NA', name: "NA" },{ id: 'LOCAL', name: "LOCAL" },{ id: 'CLOUD', name: "CLOUD"},],
  enquiryStatusList : [
    { id: 'Active', name: "Active" },
    { id: 'Passive', name: "Passive" },
    { id: 'Won', name: "Won" },
    { id: 'Lost', name: "Lost" },
  ],
  statusListWithAll: [
    { id: 'All', name: "All" },
    { id: 'Active', name: "Active" },
    { id: 'Passive', name: "Passive" },
    { id: 'Won', name: "Won" },
    { id: 'Lost', name: "Lost" },
  ],
  admissionStatusList : [
    { id: 'NEW', name: "New" },
    { id: 'Active', name: "Active" },
    { id: 'Passive', name: "Passive" },
    { id: 'Won', name: "Won" },
    { id: 'Lost', name: "Lost" },
  ],
  admissionStatusListWithAll : [
    { id: 'All', name: "All" },
    { id: 'NEW', name: "New" },
    { id: 'Active', name: "Active" },
    { id: 'Passive', name: "Passive" },
    { id: 'Won', name: "Won" },
    { id: 'Lost', name: "Lost" },
  ],
  enquirySourceList: [
    { id: 'Advertisement', name: "Advertisement" },
    { id: 'Online', name: "Online" },
    { id: 'Campaign', name: "Campaign" },
    { id: 'Friends', name: "Friends" },
  ],
  osList: [
    { id: 'win', name: "Windows" },
    { id: 'linux', name: "Linux" },
    { id: 'mac', name: "Mac OS" },
    { id: 'NA', name: "NA" },
  ],
  userTypeList: [
    { id: 'Admin', name: "Admin" },
    { id: 'System', name: "System" },
    { id: 'User', name: "User" },
  ],
  countryList : [
    { id: 'IN', name: "India" },
    { id: 'AU', name: "Australia" },
    { id: 'US', name: "USA" },
  ],
  currencyList : [
    { id: 'INR', name: "INR" },
    { id: 'USD', name: "USD" },
    { id: 'AUD', name: "AUD" }
  ],
  timezoneList : [
    { id: 'UTC', name: "UTC" },
    { id: 'IST', name: "IST" }
  ],
  dateFormatList : [
    { id: 'dd/MM/yyyy', name: "dd/MM/yyyy" },
    { id: 'MM/dd/yyyy', name: "MM/dd/yyyy" }
  ],
  roleList : [
    { id: 'USER', name: "USER" },
    { id: 'ADMIN', name: "ADMIN" },
    { id: 'MANAGER', name: "MANAGER" },
    { id: 'PARTNER', name: "PARTNER" }
  ],
  scopeList : [
    { id: 'read', name: "read" },
    { id: 'write', name: "write" }
  ],
  grantTypeList : [
    { id: 'authorization_code', name: "authorization_code" },
    { id: 'password', name: "password" },
    { id: 'client_credentials', name: "client_credentials" },
    { id: 'implicit', name: "implicit" },
    { id: 'refresh_token', name: "refresh_token" }
  ],
  roleManager : [
    { id: 'Manager', name: "Manager" }
  ],
  validityList : [
    { id: 7, name: "7 Days" },
    { id: 15, name: "15 Days" },
    { id: 30, name: "One Moth" },
    { id: 90, name: "Three Months" },
    { id: 180, name: "Six Months" },
    { id: 365, name: "One Year" }
  ],

  // These keys should be in sync with JobTypeEnum.java. because this gets saved in db from here & runtime compares with JobTypeEnum.java
  jobTypeList : [
    { id: 'PROCESS_RUN', name: "Process" },
    { id: 'BILLING', name: "Billing" },
    //{ id: 'INVOICE_GENERATOR', name: "Invoice Generator" },
    { id: 'DISABLE_USER', name: "Disable User" },
    { id: 'DISABLE_ORG', name: "Disable Organization" },
    { id: 'DELETE_ASSIST', name: "Delete Marked Assist" }, //which are marked as deleted
    { id: 'DELETE_WS', name: "Delete Marked Tenant" }, //which are marked as deleted
    { id: 'CLEAR_AUDIT_LOG', name: "Clear Audit Logs" }, // Keep for a specified time only
    { id: 'BLOCK_FREE_USER', name: "Block triel users" }, // may be 15 days
    //{ id: 'SYNC_RUN_LIMIT', name: "Block triel users" }, //// if run lumit for a plan has been updated by admin, then update same for the organizations who has subscribed to this plan
  ],
  pricePlanList : [
    { id: 'FREE_PLAN', name: "Free" },
    { id: 'STARTER', name: "Starter" },
    { id: 'PREMIUM', name: "Premium" },
    { id: 'ENTERPRISE', name: "Enterprise" },
  ],

  gitRepoList: [{ id: "http://localhost:7990/scm/dem/demo_app.git", name: "dem/demo_app" },
                { id: 'https://github.com/nilagithub/nilatestweb.git', name: "nilagithub/nilatestweb" }],
  //branch is dynamically fetched by repo
  
  SUCCESS: 'Success',
  FAILURE: 'Failure',
  STATUS_PENDING: 'STATUS_PENDING',
  STATUS_PROCESSING: 'PROCESSING',
  STATUS_COMPLETED: 'COMPLETED',

  socket_test_url: 'ws://nilatest:nilatest@localhost:8081/websocket',
  socket_auto_discon_time: 30000,// in ms i.e 15 mins= 9000000 ms

  chekck_process_run_interval: 15000, // api call for status check in every 'x' millisec
  chekck_process_run_times: 8, // number of api call 'y' for status check - total x*y=z ms 
  
  TICKET_TYPE_DEFECT: "Defect",
	TICKET_TYPE_SUPPORT: "Support",
  TICKET_OPEN:"OPEN",
	TICKET_INPROGRESS: "INPROGRESS",
	TICKET_RESOLVED: "RESOLVED",
	TICKET_CLOSED: "CLOSED",

  ticketTypeList: [
    { id: 'Defect', name: "Defect" },
    { id: 'Support', name: "Support" },
  ],
  ticketStatusList: [
    { id: 'OPEN', name: "OPEN" },
    { id: 'CLOSED', name: "CLOSED" },
    //{ id: 'INPROGRESS', name: "INPROGRESS" },
    { id: 'RESOLVED', name: "RESOLVED" },
  ],

  API_GRP_LIST: [
    { id: 'WORKZONE', name: "WORKZONE" },
    { id: 'MACHINE', name: "MACHINE" },
    { id: 'TASKBOT', name: "TASKBOT" },
    { id: 'PROCESS', name: "PROCESS" },
    { id: 'STEP', name: "STEP" },
    { id: 'ROBOASSIST', name: "ROBOASSIST" },
    { id: 'PROCESSRUN', name: "PROCESSRUN" },
    { id: 'STEPRUN', name: "STEPRUN" },
    { id: 'ASSISTRUN', name: "ASSISTRUN" },
  ],

  defaultPaginationSize: 10,
  itemCountPerPageList: [5, 10, 20, 2, 4],
  Question: 'Question',Students: 'Students',Staffs: 'Staffs',Enquiry: 'Enquiry',Admission: 'Admission',Branch: 'Branch',Board: 'Board',Stream: 'Stream',Lession: 'Lession',Topic: 'Topic',
  templateTypeList : [
    { id: 'Students', name: "Students" },
    { id: 'Staffs', name: "Staffs" },
    { id: 'Board', name: "Board" },
    { id: 'Stream', name: "Stream" },
    { id: 'Question', name: "Question" },
    { id: 'Enquiry', name: "Enquiry" },
    { id: 'Admission', name: "Admission" },
    { id: 'Lession', name: "Lession" },
    { id: 'Topic', name: "Topic" },
  ],

  ROLE_USER: 'USER',
  ROLE_SYSTEM: 'SYSTEM',
  ROLE_SUPERADMIN: 'SUPER_ADMIN',
  ROLE_ADMIN: 'ADMIN',
  ROLE_STUDENT: 'STUDENT',
  ROLE_TEACHER: 'TEACHER',
  ROLE_PARENT: 'PARENT',
  ROLE_DRIVER: 'DRIVER',
  ROLE_SALES: 'SALES',
  
  LEAVE_PENDING: 'PENDING',
  LEAVE_APPROVED: 'APPROVED',
  LEAVE_REJECTED: 'REJECTED',
  
  TRAN_FEE_CODE: 'TRANS',
  feeTypeList: [
    { id: 'Tuition Fee', name: "Tuition Fee" },
    { id: 'Transport Fee', name: "Transport Fee" },
    { id: 'Annual Fee', name: "Annual Fee" },
    { id: 'Exam Fee', name: "Exam Fee" },
    { id: 'Enrollment Fee', name: "Enrollment Fee" },
    { id: 'Library Fee', name: "Library Fee" },
    { id: 'Hostel Fee', name: "Hostel Fee" },
    { id: 'Activity Fee', name: "Activity Fee" },
    { id: 'Material Fee', name: "Material Fee" },
    { id: 'Maintenance Fee', name: "Maintenance Fee" },
    { id: 'Miscellaneous Fee', name: "Miscellaneous Fee" },
  ],
  feeFrequenceyList: [
    { id: 'Once', name: "Once" },
    { id: 'Monthly', name: "Monthly" },
    { id: 'Quarterly', name: "Quarterly" },
    { id: 'Half Yearly', name: "Half Yearly" },
    { id: 'Yearly', name: "Yearly" },
    { id: 'Other', name: "Other" },
  ],
  noticeTypeList: [
    { id: 'Circular', name: "Circular" },
    { id: 'Event', name: "Event" },
    { id: 'Announcement', name: "Announcement" },
  ],
  examTypeList: [
    { id: 'MOCK', name: "MOCK" },
    { id: 'TIME_BOUND', name: "TIME_BOUND" },
  ],
  questionTypeList: [
    { id: 'SINGLE_CHOICE', name: "SINGLE_CHOICE" },
    { id: 'MULTI_CHOICE', name: "MULTI_CHOICE" },
    { id: 'TRUE_FALSE', name: "TRUE_FALSE" },
    //{ id: 'DESCRIPTIVE', name: "DESCRIPTIVE" },
  ],
  questionLevelList: [
    { id: 'Low', name: "Low" },
    { id: 'Medium', name: "Medium" },
    { id: 'High', name: "High" },
  ],
  optionList: [
    { id: 'A', name: "A" },
    { id: 'B', name: "B" },
    { id: 'C', name: "C" },
    { id: 'D', name: "D" },
    { id: 'E', name: "E" },
    { id: 'F', name: "F" },
  ],
  trueFalse: [
    { id: 'true', name: 'true' },
    { id: 'false', name: 'false' },
  ],
  yesNo: [
    { id: 'true', name: 'Yes' },
    { id: 'false', name: 'No' },
  ],
  termList:[
    { id: 'TERM-1', name: "TERM-1" },
    { id: 'TERM-2', name: "TERM-2" },
    { id: 'TERM-3', name: "TERM-3" },
    { id: 'TERM-4', name: "TERM-4" },
    { id: 'MID_TERM', name: "MID_TERM" },
    { id: 'FINAL', name: "FINAL" },
  ],
  assessmentList:[
    { id: 'SA-1', name: "SA-1" },
    { id: 'SA-2', name: "SA-2" },
    { id: 'SA-3', name: "SA-3" },
    { id: 'PA-1', name: "PA-1" },
    { id: 'PA-2', name: "PA-2" },
    { id: 'PA-3', name: "PA-3" },
  ],
  attendanceTypeList: [
    { id: 'Present', name: "Present" },
    { id: 'Absent', name: "Absent" },
    { id: 'HalfDay', name: "HalfDay" },
    { id: 'Late', name: "Late" },
  ],
  attendanceTypeListStaff: [
    { id: 'Present', name: "Present" },
    { id: 'Absent', name: "Absent" },   
  ],
  ACTIVE: 'Active',
  PRESENT: 'Present', ABSENT: 'Absent', LEAVE: 'Leave', HALF_DAY: 'HalfDay', LATE: 'Late',
  MANUAL: 'MANUAL',QR:'QR',BIOMETRIC:'BIOMETRIC',
   NOT_PROCESSED: 'Not Processed',PROCESSED:'Processed',PAID:'Paid',PAYSLIP_GENERATED:'Payslip Generated',
  
  offWorkingCategoryList: [
    { id: 'WEEKLY_OFF', name: "WEEKLY_OFF" },
    //{ id: 'WEEKLY_OFF_HALF', name: "WEEKLY_OFF_HALF" },
    //{ id: 'HALF_DAY_OFF', name: "HALF_DAY_OFF" },
    { id: 'FULL_DAY_OFF', name: "FULL_DAY_OFF" },
    /*{ id: 'ATTENDANCE_SCHEDULER', name: "ATTENDANCE_SCHEDULER" },
    { id: 'LEAVE_APPROVAL_PERIOD', name: "LEAVE_APPROVAL_PERIOD" },*/
  ],
  offDayList: [{ id: 'Monday', name: "Monday" },{ id: 'Tuesday', name: "Tuesday" },{ id: 'Wednesday', name: "Wednesday" }, { id: 'Thursday', name: "Thursday" }, { id: 'Friday', name: "Friday" },{ id: 'Saturday', name: "Saturday" }, { id: 'Sunday', name: "Sunday" },],
  WEEKLY_OFF: 'WEEKLY_OFF',FULL_DAY_OFF: 'FULL_DAY_OFF',ATTENDANCE_SCHEDULER: 'ATTENDANCE_SCHEDULER',LEAVE_APPROVAL_PERIOD: 'LEAVE_APPROVAL_PERIOD',
  //WEEKLY_OFF_HALF: 'WEEKLY_OFF_HALF', HALF_DAY_OFF: 'HALF_DAY_OFF', 
  
  activeList:[
    { id: true, name: "Active" },{id: false, name: "In Active"}
  ],
  genderList: [
    { id: 'Male', name: "Male" },{id: 'Female', name: "Female"},{id: 'Transgender', name: "Transgender"}
  ],
  studentDocList: [
    { id: 'BIRTH_CERTIFICATE', name: "BIRTH_CERTIFICATE" },{id: 'CASTE_CERTIFICATE', name: "CASTE_CERTIFICATE"}
    ,{id: 'AADHAR_SELF', name: "AADHAR_SELF"},{id: 'RESIDENCE_PROOF', name: "RESIDENCE_PROOF"}
    ,{id: 'AADHAR_FATHER', name: "AADHAR_FATHER"},{id: 'AADHAR_MOTHER', name: "AADHAR_MOTHER"}
    ,{id: 'HEALTH_RECORD', name: "HEALTH_RECORD"}
  ],
  staffDocList: [
    { id: 'DEGREE_CERTIFICATE', name: "DEGREE_CERTIFICATE" },{id: 'EXP_CERTIFICATE', name: "EXP_CERTIFICATE"}
    ,{id: 'RESUME', name: "RESUME"},{id: 'BANK_ACCOUNT', name: "BANK_ACCOUNT"},{id: 'LAST_PAY_SLIP', name: "LAST_PAY_SLIP"}
  ],
  cloudProviderList:[
    { id: 'AWS', name: "AWS", active: true },{id: 'GCP', name: "GCP", active: false},{id: 'AZURE', name: "AZURE", active: false}
  ],
  paymentGatewayList:[
    { id: 'RAZORPAY', name: "RAZORPAY", active: true },{id: 'PAYU', name: "PAYU", active: false},{id: 'CCAVENUE', name: "CCAVENUE", active: false}
  ],
  smsGatewayList:[
    { id: 'FAST2SMS', name: "FAST2SMS", active: true },{id: 'TWILIO', name: "TWILIO", active: false},{id: 'TEXTLOCAL', name: "TEXTLOCAL", active: false}
  ],
  whatsappGatewayList:[
    { id: 'FAST2SMS', name: "FAST2SMS", active: false },{id: 'TWILIO', name: "TWILIO", active: true}
  ],
  emailGatewayList:[
    { id: 'GMAIL', name: "GMAIL", active: true },{id: 'OUTLOOK', name: "OUTLOOK", active: false},{id: 'AWSMAIL', name: "AWSMAIL", active: false}
  ],
  postalTypeList: [
    { id: 'DISPATCH', name: "DISPATCH" },
    { id: 'RECEIVE', name: "RECEIVE" },
  ],
  idTypeList: [
    { id: 'AADHAR', name: "AADHAR" },
    { id: 'VOTER_ID', name: "VOTER_ID" },
    { id: 'DL', name: "DL" },
    { id: 'PAN', name: "PAN" },
  ],
  complainTypeList: [
    { id: 'Academic', name: "Academic" },
    { id: 'Sports', name: "Sports" },
    { id: 'Hostel', name: "Hostel" },
    { id: 'Transport', name: "Transport" },
    { id: 'Fee', name: "Fee" },
    { id: 'Campus', name: "Campus" },
    { id: 'Food', name: "Food" },
  ],
  allowanceTypeList: [
    { id: 'Special Allowance', name: "Special Allowance" },
    { id: 'House Rent Allowance', name: "House Rent Allowance" },
    { id: 'Leave Travel Allowance', name: "Leave Travel Allowance" },
    { id: 'Dearness Allowance', name: "Dearness Allowance" },
    { id: 'Education Allowance', name: "Education Allowance" },
    { id: 'Hostel Allowance', name: "Hostel Allowance" },
    { id: 'Conveyance Allowance', name: "Conveyance Allowance" },
    { id: 'Medical Allowance', name: "Medical Allowance" },
    { id: 'Entertainment Allowance', name: "Entertainment Allowance" },
    { id: 'Overtime Allowance', name: "Overtime Allowance" },
    { id: 'Uniform Allowance', name: "Uniform Allowance" },
    { id: 'Miscellaneous Allowance', name: "Miscellaneous Allowance" },
  ],
  deductionTypeList: [
    { id: 'Provident Fund', name: "Provident Fund" },
    { id: 'Employee State Insurance', name: "Employee State Insurance" },
    { id: 'Professional Tax', name: "Professional Tax" },
    { id: 'Labour Welfare Fund', name: "Labour Welfare Fund" },
    { id: 'Health and Life Insurance', name: "Health and Life Insurance" },
    { id: 'Pension Plan', name: "Pension Plan" },
  ],
  leaveTypeList: [
    { id: 'Annual Leave', name: "Annual Leave" },
    { id: 'Sick Leave', name: "Sick Leave" },
    { id: 'Maternity Leave', name: "Maternity Leave" },
    { id: 'Paternity Leave', name: "Paternity Leave" },
    { id: 'Bereavement Leave', name: "Bereavement Leave" },
    { id: 'Marriage Leave', name: "Marriage Leave" },
    { id: 'Adoption Leave', name: "Adoption Leave" },
  ],
  messageTypeList:[
    { id: 'EMAIL', name: "EMAIL"},{id: 'SMS', name: "SMS"}
  ],
  gmeetStatusList: [
    { id: 'Awaited', name: "Awaited" },{id: 'Cancelled', name: "Cancelled"}
  ],
  paymentModeList: [
    { id: 'Cheque', name: "Cheque" },{id: 'Cash', name: "Cash"},{id: 'Net Banking', name: "Net Banking"},{id: 'Credit Card', name: "Credit Card"}
  ],
  
  AUTH_ENABLE: 'enable',
  AUTH_DISABLE: 'disable',
  Chatbot: 'Chatbot',
};

export const SpinnerConfig = {
  bdColor: 'rgba(0, 0, 0, 0.8)',
  type: 'timer',
  size: 'medium',
  color: '#FF0000',
  fullScreen: true,
};

/*export const TRACKER_REFRESH_TIME = 60000;
export const UI_COMMON_DATE_FORMAT_FULL = "DD/MM/YYYY hh:mm A";
export const SCHEDULER_TIME = "HH:mm";
export const UI_COMMON_DATE_FORMAT_US = 'MMM-DD-YYYY';
export const UI_COMMON_DATE_FORMAT_US_FULL = 'MMM-DD-YYYY hh:mm A'
export const TIME_ZONE = 'America/Matamoros'*/

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
